import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["backgroundAppearance", "dataTestId", "hideText", "icon", "isDisabled"];

var _templateObject, _templateObject2, _templateObject3;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import { ICON_SIZE } from "../../../icons";
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { BaseButton } from "../../blocks";
import { BUTTON_BACKGROUND_APPEARANCES, BUTTON_SIZES } from "../../constants";
import { getRem } from "./../../../core";
import { getStateStyles } from "./textButtonStateStyles";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledTextButton = styled(BaseButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n"])), function (_ref) {
  var hideText = _ref.hideText;
  return !hideText && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      padding-left: ", ";\n      padding-right: ", ";\n    "])), function (_ref2) {
    var theme = _ref2.theme;
    return theme.size.spacing.medium.value;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.size.spacing.medium.value;
  });
}, function (_ref4) {
  var hideText = _ref4.hideText,
      icon = _ref4.icon;
  return icon && !hideText && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      padding-left: ", ";\n    "])), getRem(6));
});
var TextButton = /*#__PURE__*/React.forwardRef(function (_ref5, ref) {
  var backgroundAppearance = _ref5.backgroundAppearance,
      dataTestId = _ref5.dataTestId,
      hideText = _ref5.hideText,
      icon = _ref5.icon,
      isDisabled = _ref5.isDisabled,
      other = _objectWithoutProperties(_ref5, _excluded);

  return /*#__PURE__*/_jsx(StyledTextButton, _objectSpread({
    dataTestId: dataTestId,
    hideText: hideText,
    icon: icon,
    isDisabled: isDisabled,
    ref: ref,
    stateStyles: getStateStyles(backgroundAppearance)
  }, other));
});
TextButton.propTypes = {
  /** @ignore */
  backgroundAppearance: PropTypes.oneOf(Object.values(BUTTON_BACKGROUND_APPEARANCES)),

  /** Replaces default tag: button or anchor with new value */
  customTagElement: PropTypes.string,

  /** Id value used for testing */
  dataTestId: PropTypes.string,

  /** If true, will visually hide text */
  hideText: PropTypes.bool,

  /** When URL is provided, element changes from button to hyperlink <a> */
  href: PropTypes.string,

  /** If not loading, will render specified icon before text */
  icon: PropTypes.node,

  /** Adds new class for icon element */
  iconClassName: PropTypes.string,

  /** Will set size of the icon */
  iconSize: PropTypes.oneOf(Object.values(ICON_SIZE)),

  /** Disallows user to interact with the button and adjusts appearance */
  isDisabled: PropTypes.bool,

  /** If true, will display loader and adjust width to better accommodate spinner */
  isLoading: PropTypes.bool,

  /** Loader text which will be read for screen reader users */
  loaderText: PropTypes.node,

  /** Callback that is called on click */
  onClick: PropTypes.func,

  /** Callback that is called on key down */
  onKeyDown: PropTypes.func,

  /** If true, will add vertical margins to the component */
  preserveClickableArea: PropTypes.bool,

  /** Changes button height */
  size: PropTypes.oneOf(Object.values(BUTTON_SIZES)),

  /** Will display text inside button */
  text: PropTypes.node.isRequired,

  /** Default html button 'type' attribute values when button component is used */
  type: PropTypes.string
};
TextButton.defaultProps = {
  backgroundAppearance: BUTTON_BACKGROUND_APPEARANCES.LIGHT,
  customTagElement: '',
  dataTestId: undefined,
  hideText: false,
  href: undefined,
  icon: undefined,
  iconClassName: '',
  iconSize: ICON_SIZE.DEFAULT,
  isDisabled: false,
  isLoading: false,
  loaderText: 'Loading...',
  onClick: function onClick() {},
  onKeyDown: function onKeyDown() {},
  preserveClickableArea: false,
  size: BUTTON_SIZES.STANDARD,
  type: ''
};
export { TextButton };